// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__1yOtC","light":"Sidebar_light__qm2J6","dark":"Sidebar_dark__Ak4R-"};